import { apiClient } from '@core/api/ApiClientFactory.ts';
import type { Component } from '@core/types';
import type { ComponentData, SensorCamera } from './types.ts';

export const componentService = {
    async loadComponentsForShop(shopId: string): Promise<Component[]> {
        try {
            const response = await apiClient.get(`component?shopId=${shopId}`);
            return response.data;
        } catch (error) {
            console.error('[ComponentService] Error loading components for shop:', error);
            throw error;
        }
    },

    async loadComponentIdsForShop(shopId: string): Promise<Component[]> {
        try {
            const response = await apiClient.get(`component/componentIds?shopId=${shopId}`);
            return response.data;
        } catch (error) {
            console.error('[ComponentService] Error loading component ids for shop:', error);
            throw error;
        }
    },

    async loadComponent(discriminator: string, id: string): Promise<ComponentData> {
        try {
            const response = await apiClient.get<ComponentData>(`${discriminator}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`[ComponentService] Error loading component ${discriminator}/${id}:`, error);
            throw error;
        }
    },

    async createComponent(component: ComponentData): Promise<ComponentData> {
        try {
            const response = await apiClient.post<ComponentData>(component.discriminator || '', component);
            return response.data;
        } catch (error) {
            console.error('[ComponentService] Error creating component:', error);
            throw error;
        }
    },

    async updateComponent(discriminator: string, id: string, data: ComponentData | null): Promise<ComponentData> {
        try {
            const response = await apiClient.put<ComponentData>(`${discriminator}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error(`[ComponentService] Error updating component ${discriminator}/${id}:`, error);
            throw error;
        }
    },

    async deleteComponent(discriminator: string, id: string): Promise<void> {
        try {
            await apiClient.delete<void>(`${discriminator}/${id}`);
            return;
        } catch (error) {
            console.error('[ComponentService] Error deleting component:', error);
            throw error;
        }
    },

    // Component-specific helpers
    async loadSensorCamerasForShop(shopId: string): Promise<SensorCamera[]> {
        try {
            const response = await apiClient.get<SensorCamera[]>(`sensorcamera/shop/${shopId}`);
            return response.data;
        } catch (error) {
            console.error('[ComponentService] Error loading sensor cameras for shop:', error);
            throw error;
        }
    },

    async restartGateway(deviceId: string): Promise<void> {
        try {
            await apiClient.get<void>(`gateway/${deviceId}/restart`);
            return;
        } catch (error) {
            console.error('[ComponentService] Error restarting gateway:', error);
            throw error;
        }
    }
};
